<app-page>
  <trends></trends>
</app-page>
